<template>
    <div role="tablist">
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block href="#" v-b-toggle="'accordion' + number" variant="info" class="work_color">
                    <slot name="header-title" />
                </b-button>
            </b-card-header>
            <b-collapse :id="'accordion' + number" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <slot name="body" />
                </b-card-body>
            </b-collapse>
        </b-card>
    </div>
</template>
<script>
export default {
    name: 'Accordion',
    props: {
        number: { type: Number, required: true },
    },
};
</script>
